/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';

function defineBlock(context) {
    return {
        init: function () {
            let selectRepeaterDropdown = new Blockly.FieldWidgetsDropdown(context, 'repeater', undefined, '- select -');

            this.appendDummyInput('WIDGET')
                .appendField("navigate")
                .appendField(selectRepeaterDropdown, "ID")
                .appendField("to the previous entry");

            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Navigate to the previous entry of repeater widget.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#repeater`);
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let repeaterId = block.getFieldValue('ID');
            let code = `Snap.widgets.repeater.navigateBack("${repeaterId}");\n`;
            return code;
        }
    }
}

const RepeaterNavigateBack = function (props) {
    const name = 'snap_repeater_navigate_back';
    RepeaterNavigateBack.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

RepeaterNavigateBack.propTypes = {
    context: PropTypes.object.isRequired
};

export default RepeaterNavigateBack;
